import React, { useEffect, useState } from 'react';
import {
  Stack,
  Box,
  Typography,
  CircularProgress,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Avatar,
  Grid
} from '@mui/material';
import { api } from 'src/Api';
import Label from 'src/components/Label';

export default function JobsOfferModal({ handleClose, product_id }) {
  const [loading, setloading] = useState(false);
  const [list, setlist] = useState([]);

  function getTransactions() {
    setloading(true);

    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', 'Bearer ' + token);

    const params = new URLSearchParams();
    params.append('product_id', product_id);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`${api.get_product_offers}?${params.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          throw new Error('Failed to fetch data');
        }
      })
      .then((result) => {
        setlist(result.data);
      })
      .catch((error) => {
        setlist([]);
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  useEffect(() => {
    getTransactions();
  }, []);
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'accepted':
        return 'success';
      case 'rejected':
        return 'error';
      case 'declined':
        return 'error';
      case 'refunded':
        return 'success';
      case 'pending':
        return 'warning';
      case 'cancelled':
        return 'error';
      default:
        return 'primary';
    }
  };
  return (
    <Box style={{ padding: 20, width: '100%' }}>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom textAlign={'center'}>
          Offers
        </Typography>
        {list &&
          list.map((item, index) => {
            return (
              <Box key={index}>
                {/* Product Name */}
                <Grid item xs={4} sx={{ display: 'flex' }}>
                  {/* <Typography sx={{ fontWeight: 'bold' }}>Product Name:</Typography> */}
                  <Typography sx={{ fontWeight: 'bold' }}>{item.product.name || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex' }}>
                  <Typography sx={{ fontWeight: 'bold' }}>Product Code: </Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>{item.product.code || 'N/A'}</Typography>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex' }}>
                  <Typography sx={{ fontWeight: 'bold' }}>Orignal Price: </Typography>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    {item.product.price || 'N/A'} LKR
                  </Typography>
                </Grid>
              </Box>
            );
          })}
        {loading ? (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: 30
            }}
          >
            <CircularProgress />
          </Box>
        ) : list.length > 0 ? (
          list.map((item, index) => {
            const { product, user, price, published_at, to_user, from_user, status } = item;

            return (
              <>
                <Card key={index} sx={{ marginBottom: 2 }}>
                  <CardContent style={{ padding: 0 }}>
                    <Table sx={{ width: '100%' }} aria-label="products table">
                      <TableHead>
                        <TableRow>
                          <TableCell>{'To'}</TableCell>
                          <TableCell>{'From'}</TableCell>
                          {/* <TableCell>{'Product Code'}</TableCell> */}
                          {/* <TableCell>{'Product Name'}</TableCell> */}
                          <TableCell>{'Offer Price'}</TableCell>
                          <TableCell>{'Offered On'}</TableCell>
                          <TableCell>{'Status'}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow hover>
                          <TableCell scope="row" padding="normal" style={{ width: 250 }}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <Avatar
                                alt={to_user?.name}
                                src={to_user?.avatar}
                                style={{ width: 40, height: 40, borderRadius: 20 }}
                              />
                              <Box>
                                <div className="one-line-ellipsis">{to_user?.name || 'N/A'}</div>
                                <div className="one-line-ellipsis">{to_user?.email || 'N/A'}</div>
                                {/* <div className="one-line-ellipsis">{to_user?.name}</div> */}
                                <Label
                                  style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                                  variant="ghost"
                                  color={product.user.id === to_user.id ? 'info' : 'success'}
                                  // color={getStatusColor(status)}
                                >
                                  <Typography
                                    style={{
                                      textTransform: 'capitalize',
                                      fontWeight: 'bold',
                                      fontSize: 12
                                    }}
                                  >
                                    {product.user.id === to_user.id ? 'seller' : 'buyer'}
                                  </Typography>
                                </Label>
                              </Box>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            {' '}
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <Avatar
                                alt={from_user?.name}
                                src={from_user?.avatar}
                                style={{ width: 40, height: 40, borderRadius: 20 }}
                              />
                              <Box>
                                <div className="one-line-ellipsis">{from_user?.name || 'N/A'}</div>
                                <div className="one-line-ellipsis">{from_user?.email || 'N/A'}</div>
                                <Label
                                  style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                                  variant="ghost"
                                  color={product.user.id === from_user.id ? 'info' : 'success'}

                                  // color={getStatusColor(status)}
                                >
                                  <Typography
                                    style={{
                                      textTransform: 'capitalize',
                                      fontWeight: 'bold',
                                      fontSize: 12
                                    }}
                                  >
                                    {product.user.id === from_user.id ? 'seller' : 'buyer'}
                                  </Typography>
                                </Label>
                                {/* <div className="one-line-ellipsis">{from_user?.name}</div> */}
                              </Box>
                            </Stack>
                          </TableCell>
                          {/* <TableCell>{product.name || 'N/A'}</TableCell> */}
                          <TableCell>{price ? price + ' LKR' : 'N/A'}</TableCell>
                          <TableCell>{published_at || 'N/A'}</TableCell>
                          <TableCell>
                            {status ? (
                              <Label
                                style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                                variant="ghost"
                                // color={(status === 'Declined' && 'error') || 'success'}
                                color={getStatusColor(status)}
                              >
                                <Typography
                                  style={{
                                    textTransform: 'capitalize',
                                    fontWeight: 'bold',
                                    fontSize: 12
                                  }}
                                >
                                  {status}
                                </Typography>
                              </Label>
                            ) : (
                              <Typography
                                style={{
                                  textTransform: 'capitalize',
                                  fontWeight: 'bold',
                                  fontSize: 12
                                }}
                              >
                                N/A
                              </Typography>
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
                {/* <Box>
                  <Typography>Status</Typography>
                  {status ? (
                    <Label
                      style={{ height: 30, paddingLeft: 5, paddingRight: 5, width: 80 }}
                      variant="ghost"
                      // color={(status === 'Declined' && 'error') || 'success'}
                      color={getStatusColor(status)}
                    >
                      <Typography
                        style={{
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                          fontSize: 12
                        }}
                      >
                        {status}
                      </Typography>
                    </Label>
                  ) : (
                    <Typography
                      style={{
                        textTransform: 'capitalize',
                        fontWeight: 'bold',
                        fontSize: 12
                      }}
                    >
                      N/A
                    </Typography>
                  )}
                </Box> */}
              </>
            );
          })
        ) : (
          <Typography variant="h6" gutterBottom textAlign={'center'} style={{ paddingTop: 30 }}>
            No Offers Found
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <Button onClick={handleClose} variant="outlined">
            Close
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
